import Vue from 'vue';
import { db, auth } from "../util/firebase";

export default {

    setItem (state, payload) {
        const id = payload.id;
        let item = {};

        for (let i = 0; i < state.items.length; i++) {
            if (state.items[i].id == id) {
                item = state.items[i];
                break;
            }
        }

        state.item = item;
    },

    setItems (state, payload) {
        state.items = payload.items;
    },

    addItem (state, payload) {
        state.items.push(payload.item);
    },

    replaceItem (state, payload) {
        const item = payload.item;
        state.item = item;
        for (let i = 0; i < state.items.length; i++) {
            if (state.items[i].id == item.id) {
                state.items.splice(i, 1, item);
                break;
            }
        }
    },

    setFilteredConfessions (state, payload) {
        let filteredConfessions = state.confessions.filter(confession => {
            if (state.filters.type == 'all' || state.filters.type ==  confession.type) {
                return true;
            } 
        });

        if (state.filters.search !== '') {
            filteredConfessions = filteredConfessions.filter(confession => {
                return confession.text.toLowerCase().includes(state.filters.search.toLowerCase()) 
                || confession.tags.toLowerCase().includes(state.filters.search.toLowerCase())
            });
        }

        state.filtering = true;
        state.filteredConfessions = filteredConfessions;
    },
    
    addConfession (state, payload) {
        state.confessions.unshift(payload.confession);
    },

    updateConfessionState (state, payload) {
        for (let i = 0; i < state.confessions.length; i++) {
        
            if (state.confessions[i].id == payload.id) {
                Vue.set(state.confessions[i], 'hover', payload.hover);
                return;
            }
        }
    },

    // USER \\
    // **** \\
    setUsers (state, payload) {
        const users = [];
        let localObject;

        payload.users.forEach(function(data) {
            localObject = {
                id: data.id,
                address: data.address,
                confessions: data.confessions
            } 
            users.push(localObject);
        });

        state.users = users;
    },

    // OTHER \\
    // ******* \\
    setFilters(state, payload) {
        state.filters = payload.filters;
    },

    updateLoading (state, payload) {
        state.loading = payload.loading;
    },

    updateContentLoading (state, payload) {
        state.contentLoading = payload.contentLoading;
    },

    updateHasExtension (state, payload) {
        state.hasExtension = payload.hasExtension;
    },

    updatePendingTransaction (state, payload) {
        state.pendingTransaction = payload.status;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js